// Shared pricing/billing formatting — single source consumed by cards,
// service/country pages, checkout and dashboard. No hard-coded amounts here.
export const BILLING_LABELS = {
  "one-time": "One-time fee",
  monthly: "Monthly fee",
  annual: "Annual fee",
  "per-filing": "Per filing",
  custom: "Custom quotation",
};

export function billingLabel(rec = {}) {
  return rec.billing_label || BILLING_LABELS[rec.billing_frequency] || "One-time fee";
}

export function billingSuffix(rec = {}) {
  if (rec.billing_suffix) return rec.billing_suffix;
  const f = rec.billing_frequency;
  if (f === "monthly") return "/month";
  if (f === "annual") return "/yr";
  if (f === "per-filing") return " per filing";
  return "one-time";
}

// A record needs a custom quote when its pricing/billing is unconfirmed or has no purchasable price.
export function isCustomQuote(rec = {}) {
  return (
    rec.confirmation_status === "requires_confirmation" ||
    rec.billing_frequency === "custom" ||
    rec.price == null ||
    Number(rec.price) <= 0
  );
}

export const GOV_FEE_TEXT = {
  included: "Government & registry fees included",
  excluded: "Government / registry fees billed separately",
  estimated: "Government / registry fees estimated — confirmed before payment",
};
